import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CustomerAppModule } from './app/customer-portal.module';

import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';

registerLocaleData(localeNl, 'nl-NL');

platformBrowserDynamic()
  .bootstrapModule(CustomerAppModule)
  .catch((err) => console.error(err));
